import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { NgToastModule, ToasterPosition } from 'ng-angular-popup';
import { environment } from '@/app/environments/environment';
import { LoaderSpinnerComponent } from './components/global/loader-spinner/loader-spinner.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatSlideToggleModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    NgToastModule,
    LoaderSpinnerComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'BuildXY';
  ToasterPosition = ToasterPosition;
  google_api_key = environment.apiKey;

  ngOnInit(): void {
    this.addRecaptchaScript();
  }
  addRecaptchaScript(): void {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${environment.google_recaptcha_site_key}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
}
